<template>
	<div class="account-summary">
		<div
			class="wrapper-btn-back"
			:style="`background-color:${globalColors.primary}`"
		>
			<button 
				class="account-summary-back"
				@click="$emit('close-modal')">
				<img 
					src="/static/img/arrow-back.svg"
					alt="ir hacia atras"
					class="arrow-back">
			</button>
			<p
				class="bold title-btn txt-center"
			>RESUMEN DE CUENTA</p>
		</div>
		<div class="wrapper-list-item">
			<div class="d-flex space-between align-center mb-2 btn-desktop">
				<span
					class="account-summary-title bold"
					:style="`color:${globalColors.primary}`"
				>RESUMEN DE CUENTA</span>
				<button 
					class="account-summary-btn"
					:style="`background-color:${globalColors.primary}`"
					@click="goTo('edit-user-data')">Editar</button>
			</div>
			<div class="d-flex wrap">
				<div class="list-item flex-40"><span class="bold">Nombre:</span><span> {{getUserInfo.name}}</span></div>
				<div class="list-item flex-40"><span class="bold">Apellido:</span><span> {{getUserInfo.lastname}}</span></div>
				<div class="list-item flex-40"><span class="bold">Género:</span><span> {{getGender}}</span></div>
				<div class="list-item flex-40"><span class="bold">{{countryLabels.department}}:</span><span> {{department}}</span></div>
				<div class="list-item flex-40"><span class="bold">{{countryLabels.province}}: </span><span>{{province}}</span></div>
				<div class="list-item flex-40"><span class="bold">Dirección:</span><span> {{getUserInfo.address}}</span></div>
				<div class="list-item flex-40"><span class="bold">{{countryLabels.district}}:</span><span> {{district}}</span></div>
				<div class="list-item flex-40"><span class="bold">{{documentLabel}}:</span><span> {{getUserInfo.dni}}</span></div>
				<div class="list-item flex-40"><span class="bold">RUC:</span><span> {{getUserInfo.ruc}}</span></div>
				<div class="list-item flex-40"><span class="bold">Código Postal:</span> {{getUserInfo.postalCode}}<span></span></div>
				<div class="list-item flex-40"><span class="bold">Celular:</span><span> {{setPhone}}</span></div>
				<div class="list-item flex-40"><span class="bold">Teléfono:</span><span> {{ getUserInfo.phone }}</span></div>
				<div class="list-item flex-40"><span class="bold">E-mail:</span><span> {{getUserInfo.email}}</span></div>
			</div>
			<div class="d-flex justify-center align-center mb-2 btn-mobile">
				<button
					class="account-summary-btn"
					:style="`background-color:${globalColors.primary}`"
					@click="goTo('edit-user-data')">Editar</button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

function created() {
	const { cityId, parishId, provinceId } = this.getUserInfo;
	if (cityId || parishId || provinceId) {
		this.loadData();
	}
}

function documentLabel() {
	return this.isEcuador ? 'Cédula' : 'Dni';
}

async function loadData() {
	const { cityId, parishId, provinceId } = this.getUserInfo;
	const headers = {
		Authorization: `Bearer ${this.token}`,
	};
	const requests = [
		this.$httpJapi.get(`province/${provinceId}`, { headers }),
		this.$httpJapi.get(`cities/${provinceId}`, { headers }),
		this.$httpJapi.get(`parish/${cityId}`, { headers }),
	];
	const [
		{ data: department },
		{ data: provinces },
		{ data: districts },
	] = await Promise.all(requests);
	this.department = department.name;
	this.province = provinces.find(d => d.id === cityId).name;
	this.district = districts.find(d => d.id === parishId).name;
}

function goTo(name) {
	this.$router.push({ name });
}

function setPhone() {
	return this.getUserInfo.phoneNumbers ? this.getUserInfo.phoneNumbers.join(', ') : null;
}

function getGender() {
	const { gender: genderId } = this.getUserInfo;
	const gender = this.genders.find(g => g.id === genderId);
	return gender ? gender.title : 'por definir';
}

function data() {
	return {
		gender: '',
		department: '',
		district: '',
		idClient: null,
		province: '',
	};
}


export default {
	name: 'account-summary',
	computed: {
		...mapGetters([
			'genders',
			'getUserInfo',
			'token',
		]),
		documentLabel,
		getGender,
		setPhone,
	},
	created,
	data,
	methods: {
		goTo,
		loadData,
	},
};
</script>
<style lang="scss" scoped>
	.account-summary {
		padding: 5rem;

		.list-item {
			font-size: size(maxsmall);
			margin-bottom: 4.5rem;
		}

		.bold {
			font-weight: 800;
		}

		&-title {
			font-size: size(maxsmall);
		}

		&-btn {
			border: none;
			color: color(white);
			cursor: pointer;
			font-size: size(large);
			height: 5rem;
			outline: none;
			width: 12.9rem;
		}

		.arrow-back {
			height: 1.5rem;
		}

		&-back {
			background: none;
			border: none;
			outline: none;
			position: absolute;
			top: 33%;
		}

		.wrapper-btn-back {
			display: none;
			margin-bottom: 1.6rem;
			padding: 0.1rem 1rem;
			position: relative;
		}

		.title-btn {
			color: color(white);
			font-size: size(small);
		}

		.btn-mobile {
			display: none;
		}
	}

	@media screen and (max-width: 768px) {
		.account-summary {
			padding: 0;

			.wrapper-btn-back {
				display: block;
			}

			.wrapper-list-item {
				padding: 2rem 2.5rem;
			}

			.list-item {
				flex: 1 1 100%;
				font-size: size(maxmedium);
				margin-bottom: 2rem;
			}

			&-title {
				display: none;	
			}

			.btn-mobile {
				display: flex;
			}

			.btn-desktop {
				display: none;
			}
		}
	}
</style>





// WEBPACK FOOTER //
// account-summary.vue?06ef8726